/**
 * Represents the expand modes of the PanelBar.
 * By default, the expand mode is set to `multiple`.
 */
export enum PanelBarExpandMode {
  /**
   * Allows you to expand only one item at a time.
   * When you expand an item, the item that was previously expanded is coll.
   */
  Single,

  /**
   * Allows you to expand only one item at a time and requires you to set the `height` property.
   * The expanded area occupies the entire height of the PanelBar.
   */
  Full,

  /**
   * The default mode of the PanelBar.
   * Allows you to expand more than one item at a time. Items can also be toggled.
   */
  Multiple,

  /**
   * By default, the expand mode is set to `multiple`.
   */
  Default = Multiple,
}
